<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import DropZone from "@/components/widgets/dropZone.vue";
import {helpers, required} from "@vuelidate/validators";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Transferência",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect, DropZone },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

    };
    return { dropzoneFile, drop, selectedFile, v$: useVuelidate() };
  },
  data() {
    return {

      submitMovTransfItem: false,

      loadingFornec: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingPedTipo: false,
      loadingMovTransfItem: false,

      dtListPesqFor: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      dtlistPesqPedTipo: null,
      dtlistPesqMovTransfItem: null,

      showModalFornecedor: false,
      showModalCondPgto: false,
      showModalFormaPgto: false,
      showModalPedTipo: false,
      showModalMovTransfItem: false,
      showModalObs: false,
      showModalImpXML: false,

      movTransfData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        origem: '',
        tipo: '15',
        dtemissao: new Date
      },
      fornecedorData: null,
      condPgtoData: {
        'codigo': '10',
        'descricao': '30 / 60 Dias'
      },
      formaPgtoData: {
        'codigo': '10',
        'descricao': 'Boleto'
      },
      pedTipoData: {
        'codigo': '15',
        'descricao': 'Outras Saídas'
      },
      movTransfItemData: {},
      movTransfItensData: null,

      somaPedidosFor: 0,
      ultPedsData: null,
      errosValid: null,

      idData: 0,
      updating: true,
      title: "Editar Transferência",
      items: [
        {
          text: "Estoque",
          href: "/movtransfs/list",
        },
        {
          text: "Editar Transferência",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
    };
  },
  validations: {
    movTransfItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'movTransfItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movTransfItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  },
  mounted() {
    console.log('mounted_movTransf_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Nova Solicitação de Transferência`
      this.updating = false
    }

  },

  methods:{

    confirmarXML(){
      console.log('confirmarXML')
      this.showModalImpXML = false
      this.$router.replace({
        path: `/nota/editar/0`,
        params: this.selectedFile
      })
    },

    importarXML(){
      // console.log('importarXML')
      // this.showModalImpXML = true

      this.$router.replace({
        path: `/nota/editar/0`
      })

    },


    copiar(){
      console.log('copiar')
      this.updating = true
      api.post(`${getBaseUrl()}api/movtransfcopy`, {
          'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.movTransfData = res.data

        this.idData = res.data[0].id
        this.$router.replace({ path: `/movtransf/editar/${this.idData}` })
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },

    deletarItem(iditem){
      console.log('deletarItem')
      console.log(iditem)

      if (this.movTransfData.status === 'EL'){
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.delete(`${getBaseUrl()}api/movtransfitem`, {
              params: {
                'iddata': iditem
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)
              this.carregarDados()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    calculaTotalItem(){
      console.log('calculaTotalItem')

      let quant = this.movTransfItemData.qtd
      let vlrUnit = this.movTransfItemData.vlrunitliq
      let vlrUnitTab = this.movTransfItemData.vlrunitbrt
      let percDesc = 0

      if (quant > 0 && vlrUnit > 0){

        let valorTotalItem = quant * vlrUnit
        console.log('valorTotalItem')
        console.log(valorTotalItem)

        if (vlrUnit !== vlrUnitTab){
          percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        }


        this.movTransfItemData.desconto = percDesc
        this.movTransfItemData.vlrtotalbrt = vlrUnitTab * quant
        this.movTransfItemData.vlrtotalliq = valorTotalItem
      }

    },

    confItem(){
      console.log('confItem: ' + this.idData)
      this.v$.$touch()
      this.submitMovTransfItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.movTransfItemData.empresa = this.movTransfData.empresa

        this.loadingMovTransfItem = true

        api.post(`${getBaseUrl()}api/movtransfitem`, {
          movTransfItemData: this.movTransfItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingMovTransfItem = false
          this.showModalMovTransfItem = false
          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
        
      }
    },

    novoProduto(){
      console.log('novoProduto: ' + this.idData)

      if (this.idData === 0){

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a transferência antes de adicionar item",
          showConfirmButton: false,
          timer: 1500
        })

      }else{
        this.movTransfItemData = {}
        this.showModalMovTransfItem = true
      }


    },

    detalhesProduto(idProd){
      console.log('detalhesProduto: ' + idProd)

      this.$router.push(`/produto/detalhe/${idProd}`);

      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);


    },

    editarProduto(idProd){
      console.log('editarProduto: ' + idProd)

      if (this.movTransfData.status === 'EL'){
        this.showModalMovTransfItem = true
        this.loadingMovTransfItem = true

        api.get(`${getBaseUrl()}api/movtransfitem`, {
          params: { iddata: idProd }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data[0])

          this.movTransfItemData = res.data[0]

          if (this.movTransfItemData.imgs){
            let imgTrat = this.movTransfItemData.imgs.split(',')
            this.movTransfItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          }

          this.loadingMovTransfItem = false
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmar(){
      console.log('confirmar: ' + this.idData)

      if (!this.movTransfItensData || this.movTransfItensData.length <= 0){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor adicionar produto a transferência antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Confirmação de Transferência",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true
            api.post(`${getBaseUrl()}api/movtransfconf`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)

              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Transferência confirmada com sucesso",
                showConfirmButton: false,
                timer: 1500
              }).then((res) =>{
                console.log(res)
                this.$router.push(`/movtransfs/list`)

              })
            })
          }
        })
      }
    },
    cancelar(){
      console.log('cancelar: ' + this.idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Transferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          if (this.idData > 0){
            this.updating = true
            api.post(`${getBaseUrl()}api/movtransfcanc`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)
              this.movTransfData = res.data[0]
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Transferência cancelada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })
          }else{
            this.$router.go(-1)
          }


        }
      })
    },
    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },
    alteraObs(){
      console.log('alteraObs')
      if (this.movTransfData.status === 'EL'){
        this.showModalObs = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    carregarDados(){
      api.get(`${getBaseUrl()}api/movtransf`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios _movEditar')
        console.log(res.data[1])
        this.movTransfData = res.data[0]
        this.fornecedorData = res.data[1]
        this.pedTipoData = res.data[2]
        this.formaPgtoData = res.data[3]
        this.condPgtoData = res.data[4]
        this.movTransfItensData = res.data[5]

        if (this.movTransfItensData && this.movTransfItensData.length > 0){
          this.movTransfItensData.forEach((value) => {
            let imgTrat = value.imgs.split(',')
            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            // console.log(value.vlrtotalliq);
            let valor = parseFloat(value.vlrtotalliq)
            this.valorTotalItens += valor
          });
        }

        this.idData = this.movTransfData.id
        this.title = `Editar Movimento de Transferência (${this.movTransfData.id}) ${this.fornecedorData != null ? this.fornecedorData.nome : ''}`
        this.updating = false
      });
    },
    selecionaCli(){
      console.log('selecionaCli')
      if (this.movTransfData.status === 'EL'){
        this.showModalFornecedor = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaCondPgto(){
      console.log('selecionaCondPgto')
      if (this.movTransfData.status === 'EL') {
        this.showModalCondPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaFormaPgto(){
      console.log('selecionaFormaPgto')
      if (this.movTransfData.status === 'EL') {
        this.showModalFormaPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaPedTipo(){
      console.log('selecionaPedTipo')
      if (this.movTransfData.status === 'EL') {
        console.log(this.movTransfData.tipo)
        this.showModalPedTipo = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    
    selecionaItem(){
      console.log('selecionaItem')
      if (this.movTransfData.status === 'EL') {
        this.showModalMovTransfItem = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de transferência não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarFornec(){
      console.log('confirmarFornec')
      this.showModalFornecedor = false
      this.salvar()
    },
    confirmarCondPgto(){
      console.log('confirmarCondPgto')
      this.showModalCondPgto = false
    },
    confirmarFormaPgto(){
      console.log('confirmarFormaPgto')
      this.showModalFormaPgto = false
    },
    confirmarPedTipo(){
      console.log('confirmarPedTipo')
      this.showModalPedTipo = false
    },
    confirmarItem(){
      console.log('confirmarItem')
      this.showModalMovTransfItem = false
    },

    pesqFornec(evt){
      console.log('pesqFornec')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFor = res.data
        });
      }
    },

    pesqCondPgto(evt){
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingCondPgto = true
        this.movTransfData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    pesqFormaPgto(evt){
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingFormaPgto = true
        this.movTransfData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },

    pesqPedTipo(evt){
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingPedTipo = true
        this.movTransfData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query, t: 'E', f: this.movTransfData.empresa  }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    pesqItem(evt){
      console.log('pesqItem')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqMovTransfItem = null
        this.loadingMovTransfItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqMovTransfItem = res.data

          this.dtlistPesqMovTransfItem.forEach((value) => {
            let imgTrat = value.imgs.split(',')
            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          });

        })
      }
    },

    escolheuFor(){
      console.log('escolheuFor')
      this.loadingFornec = true
      console.log(this.movTransfData.origem)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.movTransfData.origem }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.fornecedorData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFornec = false
      })
    },

    escolheuCondPgto(){
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      console.log(this.movTransfData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.movTransfData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingCondPgto = false
      })
    },

    escolheuFormaPgto(){
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      console.log(this.movTransfData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: this.movTransfData.formapgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFormaPgto = false
      })
    },

    escolheuPedTipo(){
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.movTransfData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.movTransfData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingPedTipo = false
      })
    },

    escolheuItem(){
      console.log('escolheuItem')
      this.loadingMovTransfItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.movTransfItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)

        let img1 = ''
        if (res.data[0]['imgs']){
          img1 = res.data[0]['imgs']
        }

        this.movTransfItemData = {
          movtransf_id: this.idData,
          produto_id: res.data[0]['id'],
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          img1: img1,
          qtd: 1
        }
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingMovTransfItem = false
      })
    },

    salvar(){
      console.log('salvar')
      if (this.movTransfData.origem && this.movTransfData.origem !== ''){
        console.log('salvar_00')
        this.updating = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/movtransf`, {
          movTransfData: this.movTransfData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.movTransfData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0){
            console.log('redirecionar')
            this.$router.replace({ path: `/movtransf/editar/${this.movTransfData.id}` })
            this.idData = this.movTransfData.id
            this.carregarDados()
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })



      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar origem antes de salvar a transferência",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movTransfData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvar" :disabled="movTransfData.status !== 'EL'" v-if="movTransfData.status === 'EL'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="importarXML" :disabled="true">
                <i class="bx bx-import font-size-16 align-middle me-2"></i>
                Importar XML
              </b-button>

<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimir">-->
<!--                <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
<!--                Imprimir-->
<!--              </b-button>-->

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiar">
                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>
                Copiar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="cancelar" :disabled="movTransfData.status !== 'EL'" v-if="movTransfData.status === 'EL'">
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoProduto" :disabled="movTransfData.status !== 'EL'" v-if="movTransfData.status === 'EL'">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Produto
              </b-button>


<!--                    <span-->
<!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
<!--                    >-->
<!--                      <i class="mdi mdi-cash"></i>-->
<!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
<!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
<!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button
                  class="btn btn-success"
                  @click="confirmar"
                  :disabled="movTransfData.status !== 'EL'"
                  v-if="movTransfData.status === 'EL' && movTransfItensData && movTransfItensData.length > 0">
                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR
              </button>


            </div>
          </div>
        </div>
      </div>

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-4">

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <!--                <img-->
                <!--                    src="@/assets/images/users/avatar-2.jpg"-->
                <!--                    alt=""-->
                <!--                    class="avatar-sm rounded-circle img-thumbnail"-->
                <!--                />-->
                <span
                    v-if="fornecedorData"
                    class="avatar-title rounded-circle"
                    style="max-height: 55px;
                    min-width: 55px;">{{ fornecedorData.codigo }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="text-muted">

                      <a href="javascript: void(0);" v-if="!fornecedorData" @click="selecionaCli">
                        <h5 class="mb-1 text-info">Selecionar origem ...</h5>
                      </a>

                      <a href="javascript: void(0);" v-if="fornecedorData" @click="selecionaCli">
                        <h5 class="mb-1">{{ fornecedorData.codigo }} - {{ fornecedorData.nome }}</h5>
                        <p class="mb-0">{{ fornecedorData.cidade }}, {{ fornecedorData.estado }}</p>
                      </a>

                    </div>
                  </div>

                  <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" class="ms-2" v-if="fornecedorData" target="_blank">
                    Detalhes Origem
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>

                </div>
                <hr />
                <div class="row">
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor Total</p>
                      <h5 class="mb-0">R$ {{ movTransfData.valorliq ?? formatDecimal(movTransfData.valorliq) }}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso Total</p>
                      <h5 class="mb-0">{{ movTransfData.peso ?? formatDecimal(movTransfData.peso) }} kg</h5>
                    </div>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Data</p>
                      <h5 class="mb-0">{{ formatDate(movTransfData.dtemissao) }} </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">

              <a href="javascript: void(0);" v-if="!pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ movTransfData.tipo }}</h5>
              </a>

              <a href="javascript: void(0);" v-if="pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ pedTipoData != null ? pedTipoData.descricao : '' }}</h5>
              </a>

              <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#">Visualizar Pedidos</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#">Nova Chave de Desconto</b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" v-if="!formaPgtoData" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ movTransfData.formapgto }}</p>
                </a>
                <a href="javascript: void(0);" v-if="formaPgtoData" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ formaPgtoData != null ? formaPgtoData.descricao : '' }}</p>
                </a>

                <a href="javascript: void(0);" v-if="condPgtoData" @click="selecionaCondPgto">
                  <h4 class="mb-3">{{ condPgtoData != null ? condPgtoData.descricao : '' }}</h4>
                </a>


                <p class="text-success mb-0">
                    <span
                    >0,00 % <i class="mdi mdi-arrow-right ms-1"></i
                    ></span>
                </p>
              </div>
              <div class="ms-auto align-self-end">
                <i class="bx bx-detail display-4 text-light"></i>
              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" @click="alteraObs">
                  <p class="text-warning mb-0">
                      <span>
                        {{ movTransfData.obs != null ? movTransfData.obs : 'Observações' }}
                        <i class="mdi mdi-chat-alert ms-1"></i>
                      </span>
                  </p>
                </a>

              </div>

            </div>

          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento de Valores</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td>Valor Total Bruto</td>
                  <td class="float-end">{{ formatDecimal(movTransfData.valorliq) }}</td>
                </tr>
                <tr>
                  <td>Valor Desconto</td>
                  <td class="float-end"> {{ formatDecimal(movTransfData.desconto) }}</td>
                </tr>
                <tr>
                  <td>Frete</td>
                  <td class="float-end">0,00</td>
                </tr>
                <tr>
                  <th>Valor Total Líquido</th>
                  <th class="float-end">{{ formatDecimal(movTransfData.valorliq) }}</th>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto</th>
                  <th>Descrição</th>
                  <th class="text-end">Valor Unit.(R$)</th>
                  <th class="text-end">Quantidade</th>
                  <th class="text-end">Desconto (%)</th>
                  <th class="text-end">Valor Total (R$)</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in movTransfItensData" :key="data.id">

                  <td>
                    <h5 class="text-muted mb-0">{{ data.produto }} </h5>

                  </td>

                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <a href="javascript: void(0);" class="text-body fw-bold" @click="editarProduto(data.id)">
                        {{ data.descprod.substr(0, 35) }}
                      </a>
                    </h5>
                    <p class="mb-0">
                      Saldo:
                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>
                    </p>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrunitliq) }}</td>
                  <td class="text-end">{{ formatDecimal(data.qtd) }}</td>

                  <td class="text-end">
                    <span class="badge badge-pill badge-soft-success font-size-11" v-if="data.desconto !== 0.00"
                          :class="data.desconto < 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' :  ''">
                      {{ formatDecimal(data.desconto)  }}
                    </span>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                  <td class="text-end">

                    <a href="javascript:void(0);"
                       class="action-icon text-success mx-2"
                       @click="detalhesProduto(data.produto_id)">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movTransfData.status === 'EL'"
                       class="action-icon text-warning mx-2"
                       @click="editarProduto(data.id)">
                      <i class="mdi mdi-pencil-outline font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movTransfData.status === 'EL'"
                       class="action-icon text-danger mx-2"
                       @click="deletarItem(data.id)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>

                  </td>

                </tr>



                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>

    </div>



    <b-modal :title="fornecedorData != null ? `Detalhes Origem (${ fornecedorData.nome })` : 'Detalhes Origem'" v-model="showModalFornecedor" centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Origem</label>

          <multiselect @search-change="pesqFornec"
                       @select="escolheuFor"
                       v-model="movTransfData.origem"
                       placeholder="Pesquisar fornecedor"
                       :options="dtListPesqFor"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingFornec">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ fornecedorData.codigo }} </span>
          </p>
        </router-link>
          <p class="mb-2" >
              Endereço:
              <span> {{ fornecedorData.rua }}, {{ fornecedorData.numero }}, {{ fornecedorData.bairro }}  </span>
              <span> {{ fornecedorData.cidade }} - {{ fornecedorData.estado }} </span>
          </p>
        <p class="mb-4" >
          <span> {{ fornecedorData.tel1 }} / {{ fornecedorData.email }}</span>
        </p>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap">
              <thead>
              <tr>
                <th scope="col">Últimas Transferências</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link :to="`/movtransf/editar/${data.id}`" target="_blank">
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
              </tr>
              </tbody>
            </table>
          </div>

      </div>

      <div>
        <div class="text-start mt-5">
          <router-link  to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Origem
          </router-link>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalFornecedor = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFornec">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Tipo de operação" v-model="showModalPedTipo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Novo Tipo de Operação</label>

          <multiselect id="tipooperacao"
                       @search-change="pesqPedTipo"
                       @select="escolheuPedTipo"
                       v-model="movTransfData.tipo"
                       placeholder="Pesquisar tipo de operação"
                       :options="dtlistPesqPedTipo"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Transferências</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movtransf/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarPedTipo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Forma de Pagamento" v-model="showModalFormaPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="formapgto">Selecionar Nova Forma de Pagamento</label>

          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="movTransfData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFormaPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingFormaPgto && formaPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Transferências</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movtransf/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFormaPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFormaPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal title="Detalhes Condição de Pagamento" v-model="showModalCondPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="condpgto">Selecionar Nova Condição de Pagamento</label>

          <multiselect id="condpgto"
                       @search-change="pesqCondPgto"
                       @select="escolheuCondPgto"
                       v-model="movTransfData.condpgto"
                       placeholder="Pesquisar condição de pagamento"
                       :options="dtListPesqCondPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4" >

                </span>
                <span class="mx-4" >

                  </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Transferências</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movtransf/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Alterar Observação" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="observacao">Favor informar as observações</label>
          <textarea
              id="obs"
              v-model="movTransfData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações"/>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalObs = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             :title="movTransfItemData.id != null ? `Editar Item da Transferência (${ movTransfItemData.id })` : 'Criar Novo Item na Transferência'"
             v-model="showModalMovTransfItem"
             hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Selecionar Novo Produto</label>
          <multiselect @search-change="pesqItem"
                       @select="escolheuItem"
                       v-model="movTransfItemData.produto"
                       placeholder="Pesquisar novo produto"
                       :options="dtlistPesqMovTransfItem"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqMovTransfItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end" >

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>


                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingMovTransfItem">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingMovTransfItem && movTransfItemData && movTransfItemData.descprod">

        <router-link :to="`/produto/detalhe/${movTransfItemData.produto_id}`" target="_blank" >
          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">{{ movTransfItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: 120 ({{ movTransfItemData.und }})</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!movTransfItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="movTransfItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="movTransfItemData.img1" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info">   {{ movTransfItemData.produto }} </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(movTransfItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </router-link>



          <form class="needs-validation" @submit.prevent="confItem">
            <div class="row">

              <div class="col-md-6">
                <div class="mb-3">
                  <label for="vlrunitliq">Valor Unitário</label>
                  <input
                      id="vlrunitliq"
                      v-model="movTransfItemData.vlrunitliq"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor unitário líquido"
                      :class="{'is-invalid': submitMovTransfItem && v$.movTransfItemData.vlrunitliq.$error,}"/>
                  <div v-if="submitMovTransfItem && v$.movTransfItemData.vlrunitliq.$error"
                       class="invalid-feedback">
                    <span v-if="v$.movTransfItemData.vlrunitliq.required.$message">{{ v$.movTransfItemData.vlrunitliq.required.$message }}</span>
                  </div>
                </div>
              </div>


              <div class="col-md-6">
                <div class="mb-3">
                  <label for="qtd">Quantidade</label>
                  <input
                      id="qtd"
                      v-model="movTransfItemData.qtd"
                      type="number"
                      class="form-control text-end"
                      placeholder="Quantidade"
                      :class="{'is-invalid': submitMovTransfItem && v$.movTransfItemData.qtd.$error,}"/>
                  <div v-if="submitMovTransfItem && v$.movTransfItemData.qtd.$error"
                       class="invalid-feedback">
                    <span v-if="v$.movTransfItemData.qtd.required.$message">{{ v$.movTransfItemData.qtd.required.$message }}</span>
                  </div>
                </div>
              </div>

            </div>

          </form>

        <div class="table-responsive mt-2">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Transferências</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movtransf/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Maior transf. com esta origem (2 und):</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Desconto({{ formatDecimal(movTransfItemData.desconto) }}%):</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(movTransfItemData.vlrtotalbrt - movTransfItemData.vlrtotalliq) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Valor Total Líquido do Item:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(movTransfItemData.vlrtotalliq) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div>
        <div class="row">
          <div class="text-start mt-5">
            <router-link  to="/produto/editar/0" target="_blank">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              Cadastrar Novo Produto
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="!loadingMovTransfItem && movTransfItemData && movTransfItemData.descprod">
        <div class="row">
          <div class="text-end mt-0">
            <b-button variant="light" @click="showModalMovTransfItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confItem">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>




    <b-modal title="Importar XML" v-model="showModalImpXML" centered hide-footer>
      <div class="col-md-12">
        <DropZone @drop.prevent="drop" @change="selectedFile"  />
        <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpXML = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarXML">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>



<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>

